import { createNamespacedHelpers } from 'vuex';
import { showSwal } from '@/util/swal';

import MultipleLanguage from '@/components/shared/MultipleLanguage/MultipleLanguage.vue';

const authMapper = createNamespacedHelpers('global/auth');
const globalMapper = createNamespacedHelpers('global');

export default {
	name: 'Login',
	components: {
		MultipleLanguage,
	},
	data() {
		return {
			user: {
				value: '',
				valid: false,
			},
			password: {
				value: '',
				valid: true,
			},
			isShowPassword: false,
			pageTitle: this.$t('login'),
			loginErrorMessage: '',
			USERNAME_RULES: 'usernameRequired',
			PASSWORD_RULES: 'passwordRequired',
			rememberPassword: false,
		};
	},
	computed: {
		...authMapper.mapState(['username', 'userInfo']),

		PLACEHOLDER() {
			return {
				username: this.$t('username'),
				password: this.$t('password'),
			};
		},
		rememberTitle() {
			return this.$t('rememberTitle');
		},
	},

	mounted() {
		const usernameSignup = localStorage.getItem('usernameSignup');

		const rememberedUsername = localStorage.getItem('rememberedUsername');
		const rememberedPassword = localStorage.getItem('rememberedPassword');
		const rememberedCheckbox = localStorage.getItem('rememberedCheckbox');

		rememberedCheckbox
			? ((this.user.value = rememberedUsername),
			  (this.password.value = rememberedPassword),
			  (this.rememberPassword = rememberedCheckbox))
			: ((this.user.value = ''),
			  (this.password.value = ''),
			  (this.rememberPassword = false));

		if (usernameSignup) {
			this.user.value = usernameSignup;
		}
		localStorage.removeItem('usernameSignup');
	},

	methods: {
		...authMapper.mapActions([
			'login',
			'validateToken',
			'getUserInfo',
			'getAllDetectedImageResults',
			'updateUserInfo',
		]),
		...globalMapper.mapActions(['setSpinner']),

		checkValid() {
			if (this.user.value === '') {
				this.user.valid = false;
				return false;
			}

			if (this.password.value === '') {
				this.password.valid = false;
				return false;
			}
			return true;
		},
		async onSignInButtonClick() {
			if (!this.checkValid()) return;
			this.setSpinner(true);
			try {
				let loginRes = await this.login({
					username: this.user.value,
					password: this.password.value,
				});
				let token = loginRes.data.access_token;
				localStorage.setItem('token', token);
				await this.getUserInfo(this.username);
				const userStatus = this.userInfo.activeStatus;
				if (userStatus === 'deactivated') {
					showSwal({
						type: 'info',
						title: this.$t('notifications'),
						text: this.$t('userExperiedMessage'),
					});
					this.$router.push('/profile').catch(() => {});
				} else {
					this.$router.push('/toppage').catch(() => {});
				}
			} catch (exception) {
				this.loginErrorMessage = this.$t('loginErrorMessage');
				this.user.valid = false;
				this.password.valid = false;
				this.password.value = '';
			}
			this.setSpinner(false);

			if (this.rememberPassword) {
				localStorage.setItem('rememberedUsername', this.user.value);
				localStorage.setItem('rememberedPassword', this.password.value);
				localStorage.setItem('rememberedCheckbox', this.rememberPassword);
			} else {
				localStorage.removeItem('rememberedUsername');
				localStorage.removeItem('rememberedPassword');
				localStorage.removeItem('rememberedCheckbox');
			}
		},
		onClickSignUpBtn() {
			this.$router.push('/signup').catch(() => {});
		},
		onChangeLanguage(locale) {
			this.$i18n.locale = locale;
			this.$refs.observer.validate();
		},

		togglePassword() {
			console.log('Show password');
			this.isShowPassword = !this.isShowPassword;
		},
	},
};
